import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { selectAvailableReports } from '../../store/ReportsDetailsSlice/selectors';
import { useCallback, useEffect } from 'react';
import { getAvailableReports } from '../../store/ReportsDetailsSlice/actions';
import { ALWAYS_PRESENT_REPORTS_MAP, REPORTS_INFO } from '../../constants/Reports';

export const useAvailableReports = () => {
  const dispatch = useDispatch();
  const { availableReports, isAvailableReportsLoading } = useSelector(
    selectAvailableReports
  );
  const availableReportsIds = Object.keys(availableReports);
  const alwaysPresentReportsIds = ALWAYS_PRESENT_REPORTS_MAP.map((item) => item.id)

  const getAvailableReportsHandler = useCallback(() => {
    if (availableReportsIds.length === 0) {
      dispatch(getAvailableReports());
    }
  }, [availableReportsIds.length, dispatch]);

  useEffect(() => {
    getAvailableReportsHandler();
  }, [getAvailableReportsHandler]);

  const filteredReports = Object.values(REPORTS_INFO).filter((item) => availableReportsIds.includes(item.id))

  return { filteredReports: [...filteredReports, ...ALWAYS_PRESENT_REPORTS_MAP], isReportsLoading: isAvailableReportsLoading, availableReportsIds: [...alwaysPresentReportsIds, ...availableReportsIds] };
};
